import React from 'react';

/**
 * Error alert component for displaying error messages
 */
const ErrorAlert = ({ message }) => {
  if (!message) return null;

  return (
    <div className="mb-6 bg-red-50 text-red-600 px-4 py-3 rounded-lg">
      {message}
    </div>
  );
};

export default ErrorAlert;